export default {
  titulo: "Clients",
  nuevo: "New client",
  buscar: "Search by name, document, mobile number or email",
  eliminar: "Delete client",
  pregEliminar: "Are you sure you want to delete the client?",
  editar: "Edit client",
  nombre: "Client name",
  email: "Email",
  clave: "Access password",
  personaContacto: "Contact person",
  emailAlt: "Alternative email",
  telefono: "Phone",
  celular: "Mobile",
  documento: "Document",
  direccion: "Address",
  pais: "Country",
  depto: "State/Province/Region",
  localidad: "City/Town",
  sucursalPreferida: "Preferred branch",
  textCodigoPais: "Include the country code at the beginning",
  codManual: "Manual code",
  activo: "Active",
  encuesta: "Send survey",
  director: "Manager/Responsible person",
  razon: "Company name",
  giro: "Business activity",
  contactoAdmin: "Administration contact",
  telefonoAdmin: "Administration phone",
  buscarEquipo: "Search by description, equipment type, brand or model",
  eliminarEquipo: "Remove equipment associated with the client",
  pregEliminarEquipo: "Are you sure you want to remove the equipment associated with the client?",
  pregSucursal: "Do you want to associate the equipment with one of the client's branches?",
  msgEquipoAsociado: "The equipment is already associated with this client",
  sucursales: "Client branches",
  eliminarSuc: "Delete client branch",
  pregEliminarSuc: "Are you sure you want to delete the client's branch?",
  msgErrorLimitePlan: "You cannot add more clients because it exceeds the subscribed plan"
}
